export default {
  CacheSize: 64,
  ReaderReadAHead: 95,
  UseDisk: false,
  UploadRateLimit: 0,
  TorrentsSavePath: '',
  ConnectionsLimit: 25,
  DisableDHT: false,
  DisablePEX: false,
  DisableTCP: false,
  DisableUPNP: false,
  DisableUTP: false,
  DisableUpload: false,
  DownloadRateLimit: 0,
  EnableDebug: false,
  EnableIPv6: false,
  FriendlyName: '',
  EnableRutorSearch: false,
  ForceEncrypt: false,
  PeersListenPort: 0,
  PreloadCache: 50,
  RemoveCacheOnDrop: false,
  RetrackersMode: 1,
  TorrentDisconnectTimeout: 30,
}
